import './GridLayout.scss';
import * as React from 'react';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';

type Props = JSX.IntrinsicElements['div'] & {
    readonly modificators?: ReadonlyArray<string>;
};

export function GridLayout({ className, modificators = [], ...rest }: Props): JSX.Element {
    return <div className={classList(getClasses('lvo-grid', modificators), className)} {...rest}/>;
}
